import {
	Box,
	useTheme, CircularProgress
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import React, {
	useState,
	useEffect,
	useCallback
} from 'react';
import socketCompetition from '@sockets/competition';
import {useCompetitionWordsContext} from '@context/CompetitionWordsContext';
import title from '@components/competitions/levels/move/assets/images/title.webp';
import send from '@components/competitions/levels/move/assets/images/m8/send.webp';
import d7 from '@components/competitions/levels/move/assets/images/m8/d7.webp';
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import {MessageType, MessageFrom, MessageContent} from '@components/competitions/IMessages';
import {FeedbackType, IQuestions} from '@components/competitions/IQuestions';
import update from 'immutability-helper';
import {DomEvent} from 'leaflet';
import removeListener = DomEvent.removeListener;
import axios from 'axios';
import {appConfig} from '@config';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';

type IProps = {
	state?: string
}

type LastData = {
	competition: number;
	phone: string;
	age: number;
	answer: number;
	description: string;
}
export default function Mission8(props: IProps) {
	const {state} = props;
	const theme = useTheme();
	const {t} = useTranslation();
	const [loading, setLoading] = useState(false);
	const [phoneValid, setPhoneValid] = useState<boolean | null>(null);
	const {
		setMission,
		age,
		setAge,
		answer,
		setAnswer,
		choice,
		setChoice,
		nashriye,
		setNashriye,
		description,
		setDescription,
		phone,
		setPhone,
		referralCode,
		setReferralCode,
		social,
		setSocial,
		referrerFrom
	} = useCompetitionWordsContext();
	useEffect(() => {
		setTimeout(() => {
			if (loading) {
				setLoading(false);
			}
		}, 10000);
	}, [loading]);
	const sendData = useCallback(async (lastData: LastData) => {
		try {
			if (isValidPhoneNumber(phone)) {
				setLoading(true);
				setPhoneValid(true);
				const res = await axios({
					// @ts-ignore
					url: `${appConfig.competition2.url}move`,
					method: 'POST',
					data: lastData
				});
				if (res.data.success) {
					setReferralCode(res.data.result?.referralCode);
					setMission(9);
				} else {
					console.log('err');
					setLoading(false);
				}
				// socketCompetition.emit('competition:move', lastData, (data: any) => {
				// 	if (data?.success) {
				// 		setReferralCode(data?.result?.referralCode);
				// 		setMission(9);
				// 	} else {
				// 		console.log('err');
				// 	}
				// });
			} else {
				setLoading(false);
				setPhoneValid(false);
			}
		} catch (err) {
			setLoading(false);
		}
		return () => {
			// socketCompetition.removeListener('competition:move');
		};
	}, [phone, social]);
	
	function sendDataObject() {
		let lastData = {
			competition: 2,
			phone,
			age,
			answer,
			choice,
			nashriye,
			description,
			social,
			referrerFrom
		};
		sendData(lastData);
	}
	
	return (
		<>
			<div className="flex flex-col w-full h-80 justify-center items-center gap-y-3">
				<img className="w-3/6" src={title} alt="title"/>
			</div>
			<div className="chat-words-choice flex flex-col justify-start mt-32">
				<div>
					<Box className="flex flex-col w-full gap-y-5 items-center justify-center">
						<div className="flex flex-row w-9/12">
							<div className="flex-1 rounded-3xl flex justify-center items-center">
								<img src={d7} alt={'answer1'} className="w-full"/>
							</div>
						</div>
					</Box>
					<Box className="flex flex-row w-11/12 cursor-pointer rtl m-auto mt-10">
						{/*<input className="phone-input w-full h-12 p-5 rounded-3xl rtl text-center" placeholder="شماره موبایل"/>*/}
						{/*<PhoneInput
						 inputProps={{
						 name: 'phone',
						 required: true,
						 autoFocus: true
						 }}
						 preferredCountries={['ir']}
						 country={'ir'}
						 autoFormat={true}
						 disableDropdown={true}
						 disableCountryCode={true}
						 disableSearchIcon={true}
						 // countryCodeEditable={false}
						 value={value}
						 onChange={() => setValue}
						 masks={{ir: '(....) ...-.-...'}}
						 />*/}
						<PhoneInput
							// countrySelectProps={{ unicodeFlags: true }}
							international={true}
							placeholder="شماره موبایل"
							// country="IR"
							defaultCountry="IR"
							value={phone}
							onChange={(phoneNumber) => setPhone(phoneNumber as string)}
							limitMaxLength={true}
							className={`phone-input w-10/12 h-12 p-5 rounded-3xl ltr text-center m-auto ${phoneValid == false ? 'phone-input-error border-red-800 bg-[#efb2b2]' : 'border-[#0b152b] bg-white'}`}
						/>
					</Box>
					{
						!loading && (
							<Box className="w-full flex -mt-2 justify-center">
								<div
									className="w-3/12 h-8 bg-[#0b152b] rounded-3xl text-white flex text-center items-center justify-center cursor-pointer">
									<img src={send} alt={'send'} className="w-3/6" onClick={sendDataObject}/>
								</div>
							</Box>
						)
					}
					{
						loading && (
							<div className="w-full flex justify-center my-10">
								<CircularProgress sx={{
									color: '#0b152b'
								}}/>
							</div>
						)
					}
				</div>
			</div>
		</>
	);
}
